import React from 'react'
import Image from 'next/image'
import styles from './storiesSection.module.scss'
import { type StoryItem } from '../interface/StoriesList'
import StoryBylineSection from './storyByLineSection'

interface AuthorStoryItemProps {
  item: StoryItem
}

const AuthorStoryItem: React.FC<AuthorStoryItemProps> = React.memo(({ item }) => {
  const handleHeadingClick = () => {
    window.open(item.url, '_blank')
  }

  return (
    <div className={styles.storyItem}>
      <div className={styles.storyDetails}>
        <StoryBylineSection readTime={item.readTime} contentType={item.type} publishedAt={item.publishedAt} />
        <div className={styles.storyItemHeader}>
          <div className={styles.storyTitle} onClick={handleHeadingClick}>
            {item.title}
          </div>
          <div className={styles.storyDescription}>{item.description}</div>
        </div>
      </div>
      <Image
        src={item.heroImageUrl}
        width={0}
        height={0}
        alt="Hero Image"
        loading="lazy"
        className={styles.storyHeroImage}
      />
    </div>
  )
})

export default AuthorStoryItem
